import React from "react";

function Zodiac(props) {
	const assetMap = {
		Capricorn: "https://res.cloudinary.com/drsmugc99/image/upload/v1752725732/capricorn_xh6vzt.png",
		Aquarius: "https://res.cloudinary.com/drsmugc99/image/upload/v1752725732/aquarius_r5lbwi.png",
		Pisces: "https://res.cloudinary.com/drsmugc99/image/upload/v1752725733/pisces_mzhvcj.png",
		Aries: "https://res.cloudinary.com/drsmugc99/image/upload/v1752725733/aries_g5kyh6.png",
		Taurus: "https://res.cloudinary.com/drsmugc99/image/upload/v1752725733/taurus_cyiloq.png",
		Gemini: "https://res.cloudinary.com/drsmugc99/image/upload/v1752725732/gemini_abkbes.png",
		Cancer: "https://res.cloudinary.com/drsmugc99/image/upload/v1752725732/cancer_znrfcz.png",
		Leo: "https://res.cloudinary.com/drsmugc99/image/upload/v1752725733/leo_lby5tc.png",
		Virgo: "https://res.cloudinary.com/drsmugc99/image/upload/v1752725733/virgo_pdxxre.png",
		Libra: 'https://res.cloudinary.com/drsmugc99/image/upload/v1752725733/libra_nqz49s.png',
		Scorpio: "https://res.cloudinary.com/drsmugc99/image/upload/v1752725733/scorpio_zextx2.png",
		Sagittarius: "https://res.cloudinary.com/drsmugc99/image/upload/v1752725733/sagittarius_inndna.png"
	};
	return (
		<div
			style={{
				display: "flex",
				flexDirection: "row",
				justifyContent: "center",
				marginBottom: 8
			}}
		>
			<img
				className="zodiac-icon"
				alt={props.zodiac}
				src={assetMap[props.zodiac]}
			/>
			<p className="zodiac">{props.zodiac}</p>
		</div>
	);
}

export default Zodiac;
